import { CancelablePromise, OpenAPI } from "openapi";
import { getAccessToken } from "./parseJwt";

type inputParams<K> = K & { authorization: string };

type Callback<T, K> = (input: inputParams<K>) => CancelablePromise<T>;

/**
 * Inject the auth token and manage pagination of the called api service.
 * @param callback the api service to be called
 * @param input the service params
 * @param returnFullData if true, return the full response structure, instead only the data array
 * @returns
 */

export default async function authorizedCall<T, K>(
  callback: Callback<T, K>,
  input: Omit<inputParams<K>, "authorization"> & {
    authorization?: string;
    page?: number;
    size?: number;
  },
  returnFullData: boolean = false
) {
  const jwt = getAccessToken();
  OpenAPI.TOKEN = jwt != null ? jwt : undefined;

  return callback(input as inputParams<K>)
    .then(async (data: any) => {
      // TODO: manage pagination when returnFullData = true
      if (returnFullData) {
        return data;
      }

      if (typeof data?.page === "undefined") {
        return data?._embedded?.entities ?? [];
      }

      const page = data.page;

      if (page.totalPages <= page.number + 1) {
        return data?._embedded?.entities ?? [];
      }

      input.page = page.number + 1;

      const recursiveResult: T[] = await authorizedCall(callback, input);

      return [...data._embedded.entities, ...recursiveResult];
    })
    .catch((err) => {
      throw err;
    });
}
